import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Antes me ponía nervioso al hablar con mujeres que me gustaban. Con el plan me ordené y me sentí más calmado. Ahora puedo mantener conversaciones sin ansiedad y las cosas fluyen naturalmente.',
    author: 'Mateo R., 28 años',
    location: 'Buenos Aires, Argentina',
    avatar: 'https://i.pravatar.cc/150?img=12'
  }, {
    text: 'Siempre fui el "buen amigo" pero nunca pasaba de ahí. El método me enseñó a proyectar seguridad sin fingir. Ahora siento que las mujeres me ven diferente, con más respeto.',
    author: 'Carlos M., 32 años',
    location: 'Ciudad de México, México',
    avatar: 'https://i.pravatar.cc/150?img=13'
  }, {
    text: 'Me costaba ser consistente: un día confiado, otro inseguro. Los ejercicios diarios me dieron estructura. En 2 semanas ya notaba cambios en cómo me sentía y cómo me trataban.',
    author: 'Diego S., 26 años',
    location: 'Medellín, Colombia',
    avatar: 'https://i.pravatar.cc/150?img=14'
  }, {
    text: 'Pensaba que necesitaba ser extrovertido para atraer. El método me mostró que la presencia tranquila también funciona. Ahora me siento más yo mismo y eso se nota.',
    author: 'Javier L., 30 años',
    location: 'Santiago, Chile',
    avatar: 'https://i.pravatar.cc/150?img=15'
  }, {
    text: 'Dejé de perseguir y empecé a conectar de verdad. El cambio fue mental: pasé de necesitar aprobación a ofrecer valor. Las conversaciones ahora son más fáciles y auténticas.',
    author: 'Andrés P., 29 años',
    location: 'Bogotá, Colombia',
    avatar: 'https://i.pravatar.cc/150?img=17'
  }, {
    text: 'Los checklists me salvaron. Tenía errores que no veía: postura, tono de voz, energía desesperada. Corregir eso cambió todo. Ahora proyecto seguridad sin esfuerzo.',
    author: 'Lucas F., 27 años',
    location: 'Montevideo, Uruguay',
    avatar: 'https://i.pravatar.cc/150?img=33'
  }, {
    text: 'El plan de 7 días es oro. Simple, directo, sin paja. Seguí los pasos y en una semana ya me sentía más calmado y con más claridad. Vale cada centavo.',
    author: 'Sebastián V., 31 años',
    location: 'Lima, Perú',
    avatar: 'https://i.pravatar.cc/150?img=52'
  }, {
    text: 'Me ayudó a entender que el problema no era "qué decir" sino "cómo llegar". Regulé mi energía y todo mejoró: conversaciones, primeras citas, todo. Súper recomendado.',
    author: 'Miguel A., 25 años',
    location: 'Guadalajara, México',
    avatar: 'https://i.pravatar.cc/150?img=60'
  }];
  return <section className="py-24 px-4 bg-bg-primary" data-id="element-263">
      <div className="container max-w-6xl mx-auto" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-265">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-4" data-id="element-266">
            Resultados reales
          </h2>
          <p className="text-lg text-text-secondary" data-id="element-267">
            No necesitás volverte otro. Necesitás ordenarte.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-268">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-bg-card border border-border-color p-6 rounded-xl" data-id="element-269">
              <div className="flex space-x-1 mb-4" data-id="element-270">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-urgency fill-urgency" data-id="element-271" />)}
              </div>
              <p className="text-text-normal mb-6 leading-relaxed" data-id="element-272">
                "{t.text}"
              </p>
              <div className="flex items-center justify-between" data-id="element-273">
                <div className="flex items-center space-x-3" data-id="element-274">
                  <img src={t.avatar} alt={t.author} className="w-10 h-10 rounded-full border-2 border-border-color object-cover" data-id="element-275" />
                  <div data-id="element-276">
                    <p className="text-sm font-bold text-text-primary" data-id="element-277">
                      {t.author}
                    </p>
                    <p className="text-xs text-text-secondary" data-id="element-278">{t.location}</p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}